/* eslint-disable no-param-reassign */
import get from 'lodash/get';
import cookie from 'cookie';
import catchify from 'catchify';

const initialState = () => ({
  autocompleteQuery: '',
  autocompleteProductType: null,
  autocompleteGroup: null,
  session: {
    cart: {},
  },
  csrfToken: '',
  showBodyOverlay: false,
});

export { initialState as state };

export const getters = {
  userSession: (state) => state.session.user,
  campaigns: (state) => get(state, 'session.session.campaigns', []),
  showBodyOverlay: (state) => state.showBodyOverlay,
};

export const mutations = {
  setCart(state, data) {
    state.session.cart = data;
  },

  setSession(state, data) {
    const [session, cookies] = data;
    state.session = session;

    // csrf cookie not created for some reason when hitting /browse as a anon new user.  Hack!
    // csrf needed for Experiments
    if (cookies) {
      state.csrfToken = cookies.find((c) => {
        const curCookie = cookie.parse(c);

        if (curCookie.csrftoken) {
          return c;
        }

        return false;
      }) || '';
    }
  },
  setAutocompleteQuery(state, data) {
    state.autocompleteQuery = data;
  },
  setAutocompleteProductType(state, data) {
    state.autocompleteProductType = data;
  },
  setAutocompleteGroup(state, data) {
    state.autocompleteGroup = data;
  },
  setUserAvatar(state, data) {
    state.session.user.avatar = data;
    state.session.user.avatar_small = `${data}?width=22&height=22&aspect_ratio=1:1`;
  },
  setShowBodyOverlay(state, data) {
    state.showBodyOverlay = data;
  },
};

// When the user visits a page nuxtServerInit runs on the server side which performs
// the initial enroll for global experiments and then serializes the resulting variants
// in the store across to the client.
//
// gtm-spa will handle re-issueing enrolls on navigation changes
export const actions = {
  async nuxtServerInit({ dispatch }) {
    await Promise.all([
      dispatch('browse/fetch'),
      dispatch('experiments/enroll'),
    ]);
  },

  async updateCartCount({ commit }) {
    const { $axios, $router } = this;
    const params = {
      ...$router.query,
      format: 'json',
    };

    const [err, response] = await catchify($axios.get('/api/sessions/current/', { params }));

    if (err) {
      // eslint-disable-next-line no-console
      console.log('error fetching session for store', err);
      return;
    }

    commit('setCart', response.data.cart);
  },

  setShowBodyOverlay({ commit }, data) {
    commit('setShowBodyOverlay', data);
  },
};
